module.exports = __webpack_public_path__ + "img/fondo-banner-principal.5a11b8b4.png";